<template>
    <el-popover
        :placement="placement"
        :title="title"
        :width="width"
        :trigger="trigger"
    >
        <div class="lwh_popover_wrap">
            <el-input v-model="l" placeholder="" size="mini" @blur="handleBlur">
                <template slot="prepend">L:</template>
            </el-input>
            <el-input v-model="w" placeholder="" size="mini" @blur="handleBlur">
                <template slot="prepend">W:</template>
            </el-input>
            <el-input v-model="h" placeholder="" size="mini" @blur="handleBlur">
                <template slot="prepend">H:</template>
            </el-input>
        </div>
        <slot slot="reference">
            <span>cmh</span>
        </slot>
    </el-popover>
</template>

<script>
export default {
    data() {
        return {
            l: "",
            w: "",
            h: "",
        };
    },
    props: {
        placement: {
            type: String,
            default: "top",
        },
        title: {
            type: String,
            default: "Title",
        },
        width: {
            type: Number,
            default: 200,
        },
        trigger: {
            type: String,
            default: "click",
        },
        index: {
            type: Number,
            default: 0,
        },
        row: {
            type: Object,
            default: {},
        },
        lwh: {
            type: Array,
            default: [],
        },
    },
    methods: {
        handleBlur() {
            /* console.log(this.l);
            console.log(this.w);
            console.log(this.h);
            console.log([this.l, this.w, this.h].includes("")); */
            if ([this.l, this.w, this.h].some((v) => v != "")) {
                this.$emit("handleBlur", {
                    row: this.row,
                    index: this.index,
                    lwh: {
                        length: this.l,
                        width: this.w,
                        height: this.h,
                    },
                });
            }
        },
    },
    watch: {
      lwh:{
        handler(val){
          if(val){
            this.l = val[0];
            this.w = val[1];
            this.h = val[2];
          }
        }
      }
    },
};
</script>

<style lang="scss">
.lwh_popover_wrap {
    display: flex;
    justify-content: space-around;
    .el-input {
        width: 80px;
        .el-input-group__prepend {
            padding: 0 5px;
        }
        .el-input__inner {
            padding: 0 5px;
        }
    }
}
</style>